import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'colorModel';

export class ColorModel extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
